import { getApiOriginValue } from "@/lib/utils";
import { useCallback, useMemo } from "react";

import apiConfig, { SupApiEnv } from "@/../config/api";
import { useCookies } from "next-client-cookies";

type ApiEnvSwitchReturn = [apiEnv: SupApiEnv, setApiEnv: (apiEnv: SupApiEnv) => void];

export default function useApiEnvState(): ApiEnvSwitchReturn {
  const cookies = useCookies();

  const apiEnv = useMemo(() => getApiOriginValue(cookies.get(apiConfig.cookieName) as SupApiEnv | undefined), [cookies]);

  const setApiEnv = useCallback((apiEnv: SupApiEnv) => cookies.set("api-env", apiEnv, { expires: 360 }), [cookies]);

  return [apiEnv, setApiEnv];
}
